import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

import getBrowserSessionAttributes from './browserAttributes';

export default function bootFaro() {
  try {
    if (window.faro) {
      return;
    }

    const element = document.getElementById('faro-config');
    if (!element) {
      return;
    }

    const config = JSON.parse(element.textContent);
    if (!config?.url || !config.app?.name || !config.app?.environment) {
      return;
    }

    initializeFaro({
      url: config.url,
      apiKey: config.apiKey,
      app: config.app,
      sessionTracking: {
        session: {
          attributes: getBrowserSessionAttributes(),
        },
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
      ],
    });
  } catch {
    // Monitoring must never prevent the business page from loading.
  }
}

bootFaro();
